export default "__VITE_ASSET__DDoPorQv__"